module.exports = __webpack_public_path__ + "static/img/inviteowns01.cc5cfe52.png";